export enum EAccountStatus{
    NotMentioned = 0,
    ActivationPending = 1,
    Sandbox = 2,
    PreExistingClient = 3,
    ApplicationPending = 4,
    Approved = 5,
    Integrator = 6,
    Partner = 7,
    Internal = 8,
    BizDev = 9,
    PAC = 10,
    Admin = 11
}